var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{class:[
    { 'ug-target-webim-more': _vm.showGuide }
  ],attrs:{"message":_vm.message,"show-title":false},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c(_vm.component,{tag:"component",attrs:{"message":_vm.message}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }